export default {
  stores: [],
  store: undefined,
};
